import Vue from 'vue'
import App from './App'
import router from './router/index'
import store from './store/index'
import axios from 'axios'
import VeeValidate from 'vee-validate';
import VueClipboards from 'vue-clipboards';
import moment from 'moment';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Blob from './vendor/Blob'
import Export2Excel from './vendor/Export2Excel'
import enlang from 'element-ui/lib/locale/lang/en'
import cnlang from 'element-ui/lib/locale/lang/zh-CN'
import hklang from 'element-ui/lib/locale/lang/zh-TW'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
const msg= {
    en:{...enlang},
    cn:{...cnlang},
    hk:{...hklang}
}
const i18n = new VueI18n({locale:'en',messages:msg})
Vue.use(ElementUI, {
    i18n: function(key,value) {
        return i18n.t(key,value)
    }
})

Vue.use(VueClipboards);
Vue.use(VeeValidate);
Vue.prototype.$http = axios
Vue.prototype.$moment = moment
Vue.prototype.$ALLNUM = 20000
axios.defaults.withCredentials = true
Vue.config.productionTip = false

// require("common/js/uitl").reveal()    //  暴露公用方法
require("babel-polyfill"); //  兼容ie9
require('./MultiLanguage/index') // 引入翻译

/* eslint-disable no-new */
new Vue({
        el: '#app',
        router,
        store,
        i18n,
        render: h => h(App)
    })
    // Object.prototype.mapEach = function(fn){
    //     let keys = Object.keys(this)
    //     console.log(fn(this))
    //     keys.forEach(item => this[item] = '111')
    //     // keys.forEach((item,index) => fn({[item]: this[item]}, item, this[item]))
    //     return keys
    // }
    // var o = {name:'jack',jn:'nodejs'}

// console.log(o.mapEach(m => o[m]))
// console.log(o)


// WEBPACK FOOTER //
// ./src/main.js